import React from 'react';
import { useEffect } from 'react';
import { PageViewTrackAndLogData } from '../Config/TrackAndLogData';
import GetParamURL from '../Helpers/GetParamURL';
import { addGlobalContext } from '../Helpers/DataDog';
import { Button } from '@lana-ui/login';
import ConfirmacionSinTarjetaClub from '../../src/Statics/Imgs/confirmacionSinTarjeta/confirmacionSinTarjetaClub';
import EmbedHide from '../Components/Common/Organism/EmbedHide';
import '../Statics/Scss/Pages/yaSosSuscriptor.scss';
import '../Statics/Scss/Base/Helpers.scss';
import HeaderSuscription from '../Components/Features/YaTieneSuscripcion/HeaderSuscription';
import PhoneBannerSuscription from '../Components/Features/YaTieneSuscripcion/PhoneBannerSuscription';

const YaSosSuscriptor = ({ state }) => {
    const myaccount = process.env.REACT_APP_MYACCOUNT;
    const { URLCallback } = GetParamURL();
    useEffect(() => {
        PageViewTrackAndLogData('es_suscriptor_digital');
        addGlobalContext(state.context, 'Ya compro');
    }, []);

    return (
        <>
            <ConfirmacionSinTarjetaClub />
            <HeaderSuscription />
            <EmbedHide>
                <Button
                    type="button"
                    className="--not-disabled buttonsSuscriptions"
                    label="Continuar leyendo"
                    onClick={() => {
                        window.location = `${URLCallback ? URLCallback : process.env.REACT_APP_LNREDIRECT}`;
                    }}
                />
                <Button
                    type="button"
                    className="--text-blue buttonsSuscriptions"
                    label="Administrar cuenta"
                    onClick={() => {
                        window.location = `${myaccount}mi-usuario`;
                    }}
                />
            </EmbedHide>
            <PhoneBannerSuscription />
        </>
    );
};

export default YaSosSuscriptor;
